'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var TextLink_module = require('./TextLink.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

let TextLinkTargetType = /*#__PURE__*/function (TextLinkTargetType) {
  TextLinkTargetType["SELF"] = "_self";
  TextLinkTargetType["BLANK"] = "_blank";
  return TextLinkTargetType;
}({});
const TextLink = _ref => {
  let {
    href,
    children,
    target,
    rel,
    onClick,
    linkStyle,
    includeReferrer,
    'aria-label': ariaLabel,
    'aria-controls': ariaControls,
    'aria-expanded': ariaExpanded
  } = _ref;
  const [hovered, setHovered] = React.useState(false);
  const [focused, setFocused] = React.useState(false);
  const isButton = onClick && !href;
  const textLinkTheme = {
    ...(linkStyle === null || linkStyle === void 0 ? void 0 : linkStyle.sDefault),
    ...(hovered && (linkStyle === null || linkStyle === void 0 ? void 0 : linkStyle.sHover)),
    ...(focused && (linkStyle === null || linkStyle === void 0 ? void 0 : linkStyle.sFocus))
  };
  const handleMouseEnter = () => {
    setHovered(true);
  };
  const handleMouseLeave = () => {
    setHovered(false);
  };
  const handleFocus = () => {
    setFocused(true);
  };
  const handleBlur = () => {
    setFocused(false);
  };
  if (isButton) {
    return /*#__PURE__*/React__default["default"].createElement("button", {
      className: TextLink_module["default"].textLink,
      style: textLinkTheme,
      onClick: onClick,
      "aria-label": ariaLabel,
      "aria-controls": ariaControls,
      "aria-expanded": ariaExpanded,
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
      onFocus: handleFocus,
      onBlur: handleBlur
    }, children);
  }
  return /*#__PURE__*/React__default["default"].createElement("a", {
    className: TextLink_module["default"].textLink,
    style: textLinkTheme,
    href: href,
    target: target || TextLinkTargetType.BLANK,
    rel: (target || TextLinkTargetType.BLANK) === '_blank' && !includeReferrer ? `noopener noreferrer${rel ? ` ${rel}` : ''}` : rel,
    referrerPolicy: includeReferrer ? 'no-referrer-when-downgrade' : undefined,
    onClick: onClick,
    "aria-label": ariaLabel,
    "aria-controls": ariaControls,
    "aria-expanded": ariaExpanded,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    onFocus: handleFocus,
    onBlur: handleBlur
  }, children);
};

exports.TextLinkTargetType = TextLinkTargetType;
exports["default"] = TextLink;
